/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import appContext from 'scripts/app-context';
import holeManager from 'scripts/services/hole-manager';
import can from 'can';
import template from './scorecard.stache';

const pageType = window.globalSettings.pageType;

Component.extend({
    tag: 'leaderboard-scorecard',
    template: template,
    viewModel: {
        define: {
            showVideo: {
                type: 'boolean',
                value: false,
            },
            player: {
                Type: can.Map,
                value: null,
            },
            showYards: {
                type: 'boolean',
                value: true,
            },
            round: {
                type: 'number',
                value: null,
            },
            currentRound: {
                type: 'number',
                value: null,
            },
            roundsInfo: {
                value: null,
            },
            selectedScorecard: {
                type: 'string',
                value: 'in',
            },
            availableRounds: {
                get() {
                    let rounds = [];
                    const round = this.attr('round');
                    const roundsInfo = this.attr('roundsInfo');
                    if (round) {
                        return [round];
                    }
                    if (roundsInfo) {
                        for (
                            let i = 0,
                                availableRounds =
                                    this.attr('currentRound') ||
                                    roundsInfo.length;
                            i < availableRounds;
                            i++
                        ) {
                            rounds.push(i + 1);
                        }
                        return rounds;
                    }
                    return [];
                },
            },
            analyticsVideoSource: {
                type: 'string',
                get() {
                    switch (pageType) {
                        case 'player-detail':
                            return 'Player Detail Scorecard';
                        case 'scoring':
                            return 'Leader Board Scorecard';
                        default:
                            return '';
                    }
                },
            },
        },
        getScoresOutFilter(result) {
            return result.hole.identifier <= 9;
        },
        getScoresInFilter(result) {
            return result.hole.identifier > 9;
        },
        getScoresIn(round) {
            const roundsInfo = this.attr('roundsInfo');

            if (
                round &&
                roundsInfo &&
                roundsInfo[round - 1] &&
                roundsInfo[round - 1].scorecard
            ) {
                return roundsInfo[round - 1].scorecard.holeResults.filter(
                    this.getScoresInFilter,
                );
            }
            return [];
        },
        getScoresOut(round) {
            const roundsInfo = this.attr('roundsInfo');

            if (
                round &&
                roundsInfo &&
                roundsInfo[round - 1] &&
                roundsInfo[round - 1].scorecard
            ) {
                return roundsInfo[round - 1].scorecard.holeResults.filter(
                    this.getScoresOutFilter,
                );
            }
            return [];
        },
        getRoundInfo(round) {
            const roundsInfo = this.attr('roundsInfo');
            return roundsInfo ? roundsInfo[round - 1] : null;
        },

        getScoreColor(round, hole) {
            const roundsInfo = this.attr('roundsInfo') || [];
            const roundInfo =
                roundsInfo.filter((el) => el.number === round)[0] || '';

            return roundInfo
                ? holeManager.getHoleScoreColor(
                      roundInfo.attr('scorecard'),
                      hole,
                  )
                : '';
        },
        getScorecardVideoTitle(round, hole) {
            return `${this.player.firstName} ${
                this.player.lastName
            }: Hole ${hole}, Round ${round}`;
        },
        onScoreVideoClick(video, round, hole) {
            if (video.identifier) {
                const data = _.extend(
                    { title: this.getScorecardVideoTitle(round, hole) },
                    video,
                );
                appContext.model.dispatch('highlights-video-going-play', [
                    data,
                ]);
            } else {
                console.error(`Highlights video is not configured properly`);
            }
        },
    },
    events: {
        inserted() {
            this.selectScorecard();
        },

        selectScorecard() {
            const nextHole = holeManager.getNextHole(
                this.viewModel.attr('roundsInfo'),
                this.viewModel.attr('round'),
            );
            this.viewModel.attr(
                'selectedScorecard',
                nextHole > 9 ? 'in' : 'out',
            );
        },

        '.s-switcher-btn click'($el) {
            this.viewModel.attr('selectedScorecard', $el.data('tab'));
        },
        '{scope} round'(scope, event, value) {
            this.selectScorecard();
        },
    },
});
